<div class="userSettingPages">
  <div class="headerDecs">
    <h2>CashtoCode</h2>
    <span>{{ 'desc_deposit_apcopay' | t }}</span>
  </div>

  <ng-container *ngIf="this.firststep">
    <div style="width: 100%; display: flex; justify-content: center; margin-top: 5px; margin-bottom: 5px">
      <mat-button-toggle-group name="fontStyle" aria-label="Font Style">
        <mat-button-toggle (click)="changeAmount(10)" value="10">10€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(25)" value="25">25€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(50)" value="50">50€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(100)" value="100">100€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(200)" value="200">200€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(300)" value="300">300€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(400)" value="400">400€</mat-button-toggle>
        <mat-button-toggle (click)="changeAmount(500)" value="500">500€</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <form [formGroup]="coinbaseDatas" style="width: 100%">
      <mat-form-field style="width: 100%">
        <input min="10" max="5000" matInput placeholder="{{ 'Amount' | t }}" type="number" formControlName="amount" disabled />
        <mat-error *ngIf="!coinbaseDatas.valid">
          Min : <strong>{{ this.MinValue }}</strong> - Max : <strong>{{ this.MaxValue }}</strong>
        </mat-error>
      </mat-form-field>
    </form>

    <button mat-raised-button class="form-submit-button" (click)="submitCoinbaseData()" [disabled]="!this.formvalid">{{ 'Pay' | t }}</button>
    <br /><br /><br /><br />
    <ng-container *ngIf="insicstatus != '2'">
      <div class="home-register">
        <div class="text">Für Limiterhöhung müssen sie sich komplett Verifizieren</div>
        <div class="button" [routerLink]="['/userprofile']" style="padding: 12px">{{ 'MyAccount' | t }}</div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!this.firststep">
    <iframe [src]="iframesrc" style="width: 100%; height: 1100px" (load)="paymentpageLoaded()"></iframe>
  </ng-container>
</div>
